// src/features/tenants/hooks/useDeleteTenant.ts
//
// Submission seam for the "حذف تننت" flow: owns deleting/error state
// around the real deleteTenant API call, same loading/error-state
// shape as useCreateTenant. TenantWorkspaceHeader reads through this
// hook instead of calling the API directly.

import { useState } from 'react';

import { deleteTenant } from '../api/tenants.api';

export function useDeleteTenant() {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(id: string) {
    setDeleting(true);
    setError(null);

    try {
      const success = await deleteTenant(id);
      return success;
    } catch (err) {
      setError('خطا در حذف تننت. لطفاً دوباره تلاش کنید.');
      throw err;
    } finally {
      setDeleting(false);
    }
  }

  function resetError() {
    setError(null);
  }

  return {
    submit,
    deleting,
    error,
    resetError,
  };
}
